import { useTranslation } from "react-i18next";
// Components
import { MessageContainer, MessageImg, MessageText, DismissButton } from "./styles";
// Assets
import WarningImg from "../../assets/icons/ico_warning.svg";

const DismissibleWarningMessage = ({ message, margin, onDismiss }) => {
  const [t] = useTranslation("global");

  return (
    <MessageContainer margin={margin}>
      <MessageImg src={WarningImg} alt="ico-warning" />
      <MessageText>{message}</MessageText>
      <DismissButton onClick={onDismiss}>{t("common_ok")}</DismissButton>
    </MessageContainer>
  );
};

export default DismissibleWarningMessage;
